"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Title2", {
    enumerable: true,
    get: function() {
        return Title2;
    }
});
const _createPreset = require("../createPreset");
const _useTitle2Stylesstyles = require("./useTitle2Styles.styles");
const Title2 = (0, _createPreset.createPreset)({
    useStyles: _useTitle2Stylesstyles.useTitle2Styles,
    className: _useTitle2Stylesstyles.title2ClassNames.root,
    displayName: 'Title2'
});
